import React, {useState, useEffect} from "react";
//import FullScreenSection from "./FullScreenSection";
import { Box, Heading, Center, useBreakpointValue} from "@chakra-ui/react";
import {Button as BButton} from "@mui/material"
import EastIcon from "@mui/icons-material/East"

import {VStack, HStack, Card, Image, Text, Collapse, Link} from "@chakra-ui/react"
import photo1 from "../Assets/photo1.jpg"
import photo2 from "../Assets/photo2.jpg"
import photo3 from "../Assets/photo3.jpg"
import photo4 from "../Assets/photox.jpg"
import lemonS from "../Assets/lemonS.png"
import pexels from "../Assets/pexels.jpg"
import netflix from "../Assets/netflix.png"
import spotify from "../Assets/Spotify.png"
import vidtubescreen from "../Assets/Vidtubescreen.png"



import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useInView } from "react-intersection-observer"
import {v4 as uuidv4} from 'uuid'
import { assets, workData } from "../AssetsPort/assets";
import {motion} from "motion/react"
import "typeface-ovo"



const projects = [
 {
  title: "Little lemon",
  description: " a family owned Mediterranean restaurant focused on traditional recipes served with a modern twist.",
  getImageSrc: lemonS,
  paragraph: "  A Mediterranean restaurant focused on traditional recipes served with a twist. At Little Lemon, we pride ourselves on being more than just a dining destination; we're a family-oriented Mediterranean haven where traditions come to life with a contemporary flair.",
  uuid: uuidv4(),
  number: 5
},
  
  {
    title: "React Space",
    description: "Handy tool belt to create amazing AR components in a React app, with redux integration via middleware️.",
    getImageSrc: photo1,
    paragraph: "Whether you're building an immersive vitual tour, an interactive e-commerce experience, or a gamified learning plaform. React Space provides you with an extensive set of pre-built AR components, APIs, and tools to expedite your development process.",
    uuid: uuidv4(),
    number: 1
  },

  {
    title: "React Infinite Scroll",
    description: "A scrollable bottom sheet with virtualisation support, native animations at 60 FPS and fully implemented in JS land 🔥️.",
    getImageSrc: photo2,
    paragraph: "Introduces a unique bottom sheet design that allows you to present contentin an engaging and interactive manner. Users can effortlessly pull up the content from the bottom of the screen, adding a touch of innovation to your web app. Tailor the scrollable bottom sheet to match your application's unique style and branding.",
    uuid: uuidv4(),
    number: 2
  },

  {
    title: "Photo Gallery",
    description: "A One-stop shop for photographers to share and monetize their photos, allowing them to have a second source of income.",
    getImageSrc: photo3,
    paragraph: "With a an elegant and user-friendly interface, photographers can effortlessly upload and organize their high-quality photos, creating stunning galleries that captivate viewers and potential clients. The ultimate platform for photographers looking to exhibit their creativity and turn their passion into a thriving business.",
    uuid: uuidv4(),
    number: 3
  },

  {
    title: "Event planner",
    description: "A mobile application for leisure seekers to discover unique events and activities in their city with a few taps.",
    getImageSrc: photo4,
    paragraph: "Designed to cater to leisure seekers, providing them with an effortless way to diswcover and engage with unique events and activities in their city. Leverages advanced algorithms to understand user's preferences and interests. It tailors event recommendations based on individual tastes, ensuring a truly personalized experience.",
    uuid: uuidv4(),
    number: 4
  },
];



function ProjectsSection({toggleProp, setToggle, setSelected}){
  
  let mobileView = useBreakpointValue({
    base: true,
    md: false
  })

  
  
  // This is to target the md or tablet/ipad view
  let tabletView = useBreakpointValue({
    md: true,
    lg: false
  })

  let nextHub = useBreakpointValue({
    lg:true,
    xl:false
  })



  let [isCollapsed, setIsCollapsed] = useState(true)
  let [isCollapsed2, setIsCollapsed2] = useState(true)
  let [isCollapsed3, setIsCollapsed3] = useState(true)
  let [isCollapsed4, setIsCollapsed4] = useState(true)
  let [isCollapsed5, setIsCollapsed5] = useState(true)
  let [isCollapsed6, setIsCollapsed6] = useState(true)

  let [overlay, setOverlay] = useState(false)
  let [overlay2, setOverlay2] = useState(false)
  let [overlay3, setOverlay3] = useState(false)
  let [overlay4, setOverlay4] = useState(false)
  let [overlay5, setOverlay5] = useState(false)


  let {ref: refProjects, inView: inViewProjects} = useInView({triggerOnce: false})

  useEffect((e)=>{
    
    if(inViewProjects){
      setSelected("Projects")
    }
  }, [inViewProjects])




  
 
  return(
    <div >
      <motion.div viewport={{once:true}}  initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 1}} >
      <VStack spacing={8} padding={10} alignItems="left" background={toggleProp? "#11001f":"gray.100"}  color={toggleProp? "white":"gray.700"} ref={refProjects}>  
        
        <Center>
        <VStack>
        <motion.h4 initial={{y:-20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration: 0.3, delay:0.5}} className="text-lg font-ovo">My Portfolio</motion.h4>
        <div style={{position:"relative"}}>
        <motion.div initial={{y:-20, opacity:0}} whileInView={{y:0, opacity: 1}} transition={{duration: 0.5, delay:0.5}} >
        {/* <Heading as="h2" noOfLines={1} wordBreak="break-all" size="2xl" id="projects" ref={refProjects}>Featured Projects</Heading> */}
        <h2 id="projects" className="font-ovo text-5xl text-center" style={{position:"relative", zIndex:10}}>Featured Projects</h2>

          <div style={{position:"relative"}}></div>
          <Box style={{position:"absolute", top:"0%", right:mobileView? "10%":"-10%", zIndex:0, display:toggleProp? "block":"none", pointerEvents:"none"}}>
          <img src={assets.theme_pattern} className="w-36" />      
          </Box>
        </motion.div>
        </div>
        <motion.p initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.5, delay:0.7}}  className="text-center font-ovo max-w-2xl mx-auto mt-3 ">
          Welcome to my web development portfolio! Explore a collection of projects showcasing
          my expertise in full-stack development.
        </motion.p>
        </VStack>
        </Center>

        <motion.div viewport={{once:true}}  initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.6, delay:0.9}} className="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] mb-10 mt-3 gap-5">
          {/*"group": style a child element based on hover of parent. "group-hover:bottom-7": Apply it when the parent is hovered(even if it's hovered via a child) */}
          {workData.map((f, index)=>{
            return <motion.div key={index} whileHover={{scale:1.05}} transition={{duration:0.3}} className="aspect-square bg-no-repeat bg-cover bg-center rounded-lg
            relative cursor-pointer group" style={{backgroundImage:`url(${f.bgImage})`}}>
              <div className="bg-white w-10/12 rounded-md absolute bottom-5 left-1/2 -translate-x-1/2 
              pt-3 pb-2 px-3 flex items-center justify-between duration-500 group-hover:bottom-7">
                <div>
                  <h5 className={`font-semibold ${toggleProp? "text-black":""} `}>{f.title}</h5>
                  <p className={`text-sm  ${toggleProp? "text-black":"text-gray-700"}`}>{f.description}</p>
                </div>
                {/*transition-property(ies): background-color, border-color, color, fill, stroke, opacity, box-shadow, transform */}
                <div className="border rounded-full border-black w-9 aspect-square flex items-center
                justify-center shadow-[2px_2px_0_#000] group-hover:bg-lime-300 transition">
                  <img src={assets.send_icon} alt="send icon" className="w-5" />
                </div>

              </div>

            </motion.div>
          })}
        </motion.div>

        

           {/* <motion.a href="" initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.5, delay:1.1}}  className={`w-max flex mb-20 items-center gap-3 px-10 py-2.5 border-[0.5px] ${toggleProp? "border-white text-white":"border-gray-700 text-gray-700"}
           rounded-full ml-4 mx-auto ${toggleProp? "hover:bg-[#11002f]":"hover:bg-[#fcf4ff]"} duration-500 `}>
            Show more <img src={toggleProp? assets.right_arrow_bold_dark:assets.right_arrow_bold} alt="Right arrow" className="w-3" />
          </motion.a>  */}

          <motion.div viewport={{once:true}} className="mb-10 " initial={{opacity:0}} whileInView={{opacity: 1}} transition={{duration: 0.5, delay:1.1}} > {/*Default mb-20 */}
          <Center >
          <BButton variant="contained" endIcon={<EastIcon />} sx={{px:4, borderRadius:"50px", color:toggleProp?"white":"#374151", textTransform:"none", background:"transparent", border:toggleProp? "1px solid white":"1px solid #374151", mt:1, '&:focus':{ boxShadow: `0 0 0 4px ${toggleProp?"black":"white"}, 0 0 0 8px ${toggleProp? "white":"black"}`}, '&:hover':{background:toggleProp? "#11002f":"#fcf4ff"} }} ><span style={{fontWeight:"bold", padding:4}} >Show more</span></BButton>
          </Center>
          </motion.div>

        
        <Box display="grid" ml={mobileView? -5: (tabletView||nextHub? -10: "")} mr={mobileView? -5: (tabletView||nextHub? -10: "")} paddingLeft={mobileView? 0:10} paddingRight={mobileView? 0:10} gridTemplateColumns= {mobileView? "1fr": "1fr 1fr"} gap={8} >
         
          <Card borderRadius={10} cursor="pointer" _hover={{transform: "scale(1.05)", boxShadow: "0px 0px 50px black", transition: "transform 0.3s ease-in-out"}} bg={toggleProp && "#18181b"} color={toggleProp && "white"} >
              
              <Box  onMouseDown={(e)=> setOverlay(true)} onMouseUp={(e)=> setOverlay(false)} onMouseLeave={(e)=> setOverlay(false)} onMouseEnter={(e)=>{
              if(tabletView || mobileView) {
                setOverlay(true)
              }
              }}
              >
             
               {/* Creating Overlay */}
        {overlay && <div style = {{
                background: "rgba(34,167,240,0.5)",
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100%", 
                height: "100%",
                zIndex: 0,
                pointerEvents: "none" //This prevent overlay from receiving mouse events but it allows it to pass through to the element underneath.
              }}>    
              </div>
            }
              <Link href="https://app.benasenso.com"  isExternal>      
              <Image src={lemonS} loading="lazy" borderRadius={10} height={[327, 427]} objectFit="cover"/>              
              </Link>
                     
              </Box>
      
              
                  
              <Box p={8} >
              <Heading as="h3" size="md">Little Lemon</Heading>
              
              <Text color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
              A family owned Mediterranean restaurant focused on traditional recipes served with a modern twist.
              </Text>
              
              <Collapse in={!isCollapsed}>
              <Text fontSize={["md", "lg"]} color={toggleProp? "white":"#64748b"}>
                A Mediterranean restaurant focused on traditional recipes served with a twist. At Little Lemon, we pride ourselves on being more than just a dining destination; we're a family-oriented Mediterranean haven where traditions come to life with a contemporary flair.
              </Text>
              </Collapse>

              <HStack mt={-4} spacing={2}>
              <Text mt={4} _active={{bg: "rgba(34,167,240,0.5)", color: "red"}} onClick={(e) => {
                setIsCollapsed(!isCollapsed)
              }}>{isCollapsed? "See More":"See Less"} </Text>
              
             {isCollapsed? <FontAwesomeIcon icon={faArrowRight}onClick={(e) => {
                setIsCollapsed(!isCollapsed)
              }}></FontAwesomeIcon> : <FontAwesomeIcon icon={ faArrowLeft} onClick={(e) => {
                setIsCollapsed(!isCollapsed)
              }}></FontAwesomeIcon>}
              </HStack>
              </Box>
            </Card>
    
            
          
             <Card borderRadius={10} cursor="pointer"  _hover={{transform: "scale(1.05)", boxShadow: "0px 0px 50px black", transition: "transform 0.3s ease-in-out"}} color={toggleProp && "white"} bg={toggleProp && "#18181b" } >
          
             <Box  onMouseDown={(e)=> setOverlay3(true)} onMouseUp={(e)=> setOverlay3(false)} onMouseLeave={(e)=> setOverlay3(false)} onMouseEnter={(e)=>{
              if(tabletView || mobileView) {
                setOverlay3(true)
              }
              }}
              >
             
               {/* Creating Overlay */}
        {overlay3 && <div style = {{
                background: "rgba(34,167,240,0.5)",
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100%",
                height: "100%",
                zIndex: 0,
                pointerEvents: "none" //This prevent overlay from receiving mouse events but it allows it to pass through to the element underneath.
              }}>    
              </div>
            }
              <Link href="https://stagingntfx-daf90.web.app"  isExternal>            
              <Image src={netflix} loading="lazy" borderRadius={10} height={[327, 427]} objectFit="cover" />      
              </Link>
                     
              </Box>
      
              
              <Box p={8} >
              <Heading as="h3" size="md"> Netflix</Heading>
              
              <Text size="3xl" color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
              Netflix offers users a seamless experience for browsing and streaming movies and tv shows.
              </Text>
              
              <Collapse in={!isCollapsed2}>
              <Text fontSize={["md", "lg"]} color={toggleProp? "white": "#64748b"}>
              Designed for an optimal user experience, it allows members to browse through genres, discover trending titles, and view detailed descriptions and reviews for each show.
              Users can enjoy a smooth interface for watching content on-demand, all while getting tailored recommendations based on their viewing habits.
              </Text>
              </Collapse>

              <HStack mt={-4} spacing={2}>
              <Text mt={4} _active={{bg: "rgba(34,167,240,0.5)", color: "red"}} onClick={(e) => {
                setIsCollapsed2(!isCollapsed2)
              }}>{isCollapsed2? "See More":"See Less"} </Text>
              
             {isCollapsed2? <FontAwesomeIcon icon={faArrowRight}onClick={(e) => {
                setIsCollapsed2(!isCollapsed2)
              }}></FontAwesomeIcon> : <FontAwesomeIcon icon={ faArrowLeft} onClick={(e) => {
                setIsCollapsed2(!isCollapsed2)
              }}></FontAwesomeIcon>}
              </HStack>
              </Box>
            </Card>
          


            <Card borderRadius={10} cursor="pointer"  _hover={{transform: "scale(1.05)", boxShadow: "0px 0px 50px black", transition: "transform 0.3s ease-in-out"}}  bg={toggleProp && "#18181b"} color={toggleProp && "white"}>

            <Box  onMouseDown={(e)=> setOverlay4(true)} onMouseUp={(e)=> setOverlay4(false)} onMouseLeave={(e)=> setOverlay4(false)} onMouseEnter={(e)=>{
              if(tabletView || mobileView) {
                setOverlay4(true)
              }
              }}
              >
             
               {/* Creating Overlay */}
        {overlay4 && <div style = {{
                background: "rgba(34,167,240,0.5)",
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100%",
                height: "100%",
                zIndex: 0,
                pointerEvents: "none" //This prevent overlay from receiving mouse events but it allows it to pass through to the element underneath.
              }}>    
              </div>
            }
              <Link href="https://stagingspty.web.app"  isExternal>            
              <Image src={spotify} loading="lazy" borderRadius={10} height={[327, 427]} objectFit="cover" />      
              </Link>
                     
              </Box>
              
              <Box p={8} >
              <Heading as="h3" size="md">Spotify</Heading>
              
              <Text size="3xl" color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
              Spotify is a music streaming platform offering seamless and immersive listening experience to users.
              </Text>
              
              <Collapse in={!isCollapsed3}>
              <Text fontSize={["md", "lg"]} color={toggleProp? "white": "#64748b"}>
              With a built-in playlist management system, users can create, edit and organize playlists effortlessly.
              The search functionality makes it easy to discover songs, albums and artists while a favorites feature enables users to save and revisit their preferred tracks.
              The interface is sleek, responsive and optimized for smooth navigation across all devices.
              </Text>
              </Collapse>

              <HStack mt={-4} spacing={2}>
              <Text mt={4} _active={{bg: "rgba(34,167,240,0.5)", color: "red"}} onClick={(e) => {
                setIsCollapsed3(!isCollapsed3)
              }}>{isCollapsed3? "See More":"See Less"} </Text>
              
             {isCollapsed3? <FontAwesomeIcon icon={faArrowRight}onClick={(e) => {
                setIsCollapsed3(!isCollapsed3)
              }}></FontAwesomeIcon> : <FontAwesomeIcon icon={ faArrowLeft} onClick={(e) => {
                setIsCollapsed3(!isCollapsed3)
              }}></FontAwesomeIcon>}
              </HStack>
              </Box>
            </Card>


            <Card borderRadius={10} cursor="pointer"  _hover={{transform: "scale(1.05)", boxShadow: "0px 0px 50px black", transition: "transform 0.3s ease-in-out"}} bg={toggleProp && "#18181b"} color={toggleProp && "white"}>
              
              <Box  onMouseDown={(e)=> setOverlay5(true)} onMouseUp={(e)=> setOverlay5(false)} onMouseLeave={(e)=> setOverlay5(false)} onMouseEnter={(e)=>{
              if(tabletView || mobileView) {
                setOverlay5(true)
              }
              }}
              >
             
               {/* Creating Overlay */}
        {overlay5 && <div style = {{
                background: "rgba(34,167,240,0.5)",
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100%",
                height: "100%",
                zIndex: 0,
                pointerEvents: "none" //This prevent overlay from receiving mouse events but it allows it to pass through to the element underneath.
              }}>    
              </div>
            }
              <Link href="https://vidtube.benasenso.com"  isExternal>            
              <Image src={vidtubescreen} loading="lazy" borderRadius={10} height={[327, 427]} objectFit="cover" />      
              </Link>
                     
              </Box>
              
              <Box p={8} >
              <Heading as="h3" size="md">VidTube</Heading>
              
              <Text size="3xl" color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
              VidTube - A video sharing platform where users can discover trending videos and subscribe to their favorite creators.
              </Text>
              
              <Collapse in={!isCollapsed4}>
              <Text fontSize={["md", "lg"]} color={toggleProp? "white": "#64748b"}>
              Build personalised watchlists, playlists and upload your own content seamlessly.
              Users can organize videos into playlists, save favorites to watch later and interact with content through likes and comments. The platform supports uploading videos, subdcribing to channels and exploring trending content 
              through advanced search and recommendation features.
              Designed for smooth navigation and engaging viewing experience on any device.

              </Text>
              </Collapse>

              <HStack mt={-4} spacing={2}>
              <Text mt={4} _active={{bg: "rgba(34,167,240,0.5)", color: "red"}} onClick={(e) => {
                setIsCollapsed4(!isCollapsed4)
              }}>{isCollapsed4? "See More":"See Less"} </Text>
              
             {isCollapsed4? <FontAwesomeIcon icon={faArrowRight}onClick={(e) => {
                setIsCollapsed4(!isCollapsed4)
              }}></FontAwesomeIcon> : <FontAwesomeIcon icon={ faArrowLeft} onClick={(e) => {
                setIsCollapsed4(!isCollapsed4)
              }}></FontAwesomeIcon>}
              </HStack>
              </Box>
            </Card>


            <Card borderRadius={10} cursor="pointer"  _hover={{transform: "scale(1.05)", boxShadow: "0px 0px 50px black", transition: "transform 0.3s ease-in-out"}} bg={toggleProp && "#18181b"} color={toggleProp && "white"}>
              <Image src={photo4} loading="lazy" borderRadius={10} height={[327, 427]} objectFit="cover" />
              
              <Box p={8} >
              <Heading as="h3" size="md">Event Planner</Heading>
              
              <Text size="3xl" color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
              A mobile application for leisure seekers to discover unique events and activities in their city with a few taps.
              </Text>
              
              <Collapse in={!isCollapsed5}>
              <Text fontSize={["md", "lg"]} color={toggleProp? "white": "#64748b"}>
              Designed to cater to leisure seekers, providing them with an effortless way to diswcover and engage with unique events and activities in their city. Leverages advanced algorithms to understand user's preferences and interests. It tailors event recommendations based on individual tastes, ensuring a truly personalized experience.
              </Text>
              </Collapse>

              <HStack mt={-4} spacing={2}>
              <Text mt={4} _active={{bg: "rgba(34,167,240,0.5)", color: "red"}} onClick={(e) => {
                setIsCollapsed5(!isCollapsed5)
              }}>{isCollapsed5? "See More":"See Less"} </Text>
              
             {isCollapsed5? <FontAwesomeIcon icon={faArrowRight}onClick={(e) => {
                setIsCollapsed5(!isCollapsed5)
              }}></FontAwesomeIcon> : <FontAwesomeIcon icon={ faArrowLeft} onClick={(e) => {
                setIsCollapsed5(!isCollapsed5)
              }}></FontAwesomeIcon>}
              </HStack>
              </Box>
            </Card>


            <Card borderRadius={10} cursor="pointer"  _hover={{transform: "scale(1.05)", boxShadow: "0px 0px 50px black", transition: "transform 0.3s ease-in-out"}} bg={toggleProp && "#18181b"} color={toggleProp && "white"}>
              
              <Box  onMouseDown={(e)=> setOverlay2(true)} onMouseUp={(e)=> setOverlay2(false)} onMouseLeave={(e)=> setOverlay2(false)} onMouseEnter={(e)=>{
              if(tabletView || mobileView) {
                setOverlay2(true)
              }
              }}
              >
             
               {/* Creating Overlay */}
        {overlay2 && <div style = {{
                background: "rgba(34,167,240,0.5)",
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100%",
                height: "100%",
                zIndex: 0,
                pointerEvents: "none" //This prevent overlay from receiving mouse events but it allows it to pass through to the element underneath.
              }}>    
              </div>
            }
              <Link href="https://blogai.benasenso.com"  isExternal>            
              <Image src={pexels} loading="lazy" borderRadius={10} height={[327, 427]} objectFit="cover" />      
              </Link>
                     
              </Box>
      
              

              <Box p={8} >
              <Heading as="h3" size="md">AI Blog Generator</Heading>
              
              <Text size="3xl" color={toggleProp? "white": "#64748b"} fontSize={["md", "lg"]} >
              A revolutionary that offers a sleek and intuitive interface for users to interact with advanced AI functionalities.
              </Text>
              
              <Collapse in={!isCollapsed6}>
              <Text fontSize={["md", "lg"]} color={toggleProp? "white": "#64748b"}>
              AI Blog Generator offers seamless way to transform video content to comprehensive written articles while ensuring high-quality, engaging content.  
              With its cutting-edge AI technology to deliver accurate and coherent blog posts , AI Blog Generator sets a new standard for user-centric design, ushering in a new era of innovation in the digital landscape.
              </Text>
              </Collapse>

              <HStack mt={-4} spacing={2}>
              <Text mt={4} _active={{bg: "rgba(34,167,240,0.5)", color: "red"}} onClick={(e) => {
                setIsCollapsed6(!isCollapsed6)
              }}>{isCollapsed6? "See More":"See Less"} </Text>
              
             {isCollapsed6? <FontAwesomeIcon icon={faArrowRight}onClick={(e) => {
                setIsCollapsed6(!isCollapsed6)
              }}></FontAwesomeIcon> : <FontAwesomeIcon icon={ faArrowLeft} onClick={(e) => {
                setIsCollapsed6(!isCollapsed6)
              }}></FontAwesomeIcon>}
              </HStack>
              </Box>
            </Card>
           
          
        </Box>
          
            
        
      </VStack>
      </motion.div>
    </div>
  )
  }



export default ProjectsSection;
